import IconButton from '@mui/material/IconButton';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { HeaderOpt } from './_type';

import Arranger from '~/client/components/base/arranger';
import { MoveRight3, MoveLeft3 } from '~/client/components/base/icon';
import { spc } from '~/client/components/base/spacer';
import Text from '~/client/components/base/text';

interface Props extends HeaderOpt {
  className?: string;
  open?: boolean;
  onClick?: () => void;
}

const QuickActionHeaderImpl: React.FC<Props> = ({
  className,
  text,
  open,
  onClick,
}) => {
  // Icon for controlling open/close of drawer
  const Icon = open ? MoveRight3 : MoveLeft3;

  // Title to be displayed beside the icon when drawer is opened
  let title = '';
  if (open && text) {
    title = text;
  }

  return (
    <Arranger
      className={className}
      alignItems="center"
      justify="space-between"
      sx={{
        mx: spc.container_padding_m,
        mt: spc.container_padding_m,
        mb: spc.container_padding_l,
      }}
    >
      <Text sz="title-small">{title}</Text>
      <IconButton onClick={onClick}>
        <Icon />
      </IconButton>
    </Arranger>
  );
};

export const QuickActionHeader = muiStyled(QuickActionHeaderImpl)(({
  theme,
}) => {
  const textColor = theme.palette.text.primary;

  return css`
    /* Restrict button to 16px */
    .MuiIconButton-root {
      padding: 0;

      .MuiSvgIcon-root {
        font-size: 16px;
        color: ${textColor};
      }
    }
  `;
});
